import { Box, Fade } from '@chakra-ui/react';
import React from 'react';

import ImageHandler from '../../ImageHandler';

interface ImageFaderProps {
  images: StaticImageDef[] | React.ReactElement[];
  periodMs?: number;
}

const DEFAULT_PERIOD_MS = 4000;

const ImageFader: React.FC<ImageFaderProps> = ({
  images,
  periodMs = DEFAULT_PERIOD_MS,
}) => {
  const [imageIndex, setImageIndex] = React.useState(0);

  React.useEffect(() => {
    const timeout = setInterval(() => {
      // Rotate index to next image
      setImageIndex((val) => (val + 1) % images.length);
    }, periodMs);

    // Unregister rotation timeout when component unmounts, or when # of images or period changes
    return () => {
      timeout && clearInterval(timeout);
    };
  }, [periodMs, images.length]);

  const image = images[imageIndex];
  return (
    <Box
      width="fit-content"
      height="fit-content"
      padding="12px"
      background="white"
      borderRadius="16px"
    >
      <Fade key={imageIndex} in>
        <ImageHandler image={image} />
      </Fade>
    </Box>
  );
};

export default ImageFader;
